/* LIBRAIRIES */
import React, { useEffect, useState } from 'react';

/* COMPONENTS */
import DataGridMedias from '../DataGridMedias/DataGridMedias';

/* FIREBASE */
import { list, ref, getDownloadURL, getMetadata } from 'firebase/storage';
import { storage } from '../../firebase';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* CSS */
import "./UserDocs.css";

const UserDocs = ({ userId, userInfos }) => {
    const [userFiles, setUserFiles] = useState([]);
    const [refreshDocs, setRefreshDocs] = useState(false);
    const { userMediasList } = useUserContext();

    useEffect(() => {
        async function getUserFiles() {
            const userFilesRef = ref(storage, `medias/${userId}`);
            const userFilesList = await list(userFilesRef);

            const userFilesArray = [];
            await Promise.all(userFilesList.items.map(async (itemRef) => {
                const downloadUrl = await getDownloadURL(itemRef);
                const metadata = await getMetadata(itemRef);
                userFilesArray.push({
                    id: itemRef.name,
                    url: downloadUrl,
                    dateCreated: metadata.timeCreated,
                    dateUpdated: metadata.updated,
                    size: metadata.size,
                    contentType: metadata.contentType,
                    firstName: metadata?.customMetadata?.firstName,
                    name: metadata?.customMetadata?.lastName,
                    titre: metadata?.customMetadata?.title
                });
            }));

            setUserFiles(userFilesArray);
        }

        getUserFiles();
    }, [refreshDocs]);

    return (
        <div className='container-userdocs'>
            {
                userFiles && <DataGridMedias userId={userId} refreshDocs={refreshDocs} setRefreshDocs={setRefreshDocs} userMedias={userFiles} composant="docs" />
            }
        </div>
    );
};

export default UserDocs;
